import { mediaMax } from '@/app/styles/breakpoints'
import { Button } from '@/shared/ui'
import { Flex, Modal } from 'antd'
import styled from 'styled-components'

export const HeaderContainer = styled.header`
  background: white;
  color: #333;
  padding: 0 16px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 4px 16px 0px #0c10181f;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 10;
`

export const LeftSection = styled(Flex)``

export const LogoSection = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  cursor: pointer;
`

export const Logo = styled.img`
  height: 24px;
  width: 345px;
  object-fit: contain;
  ${mediaMax.sm} {
    width: 42px;
  }
`

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const NavMenu = styled.nav`
  display: flex;
  gap: 16px;
`

export const NavButton = styled(Button)<{ isActive?: boolean }>`
  ${mediaMax.lg} {
    padding: 0;
    width: 40px;
  }
`

export const LogoutButton = styled.button`
  background: transparent;
  border: 1px solid #d9d9d9;
  color: #666;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
`

export const AboutModal = styled(Modal)`
  && {
    .ant-modal-content {
      box-shadow: none;
    }
    .ant-modal-header {
      margin-bottom: 28px;
    }
    .ant-modal-body {
      text-align: center;
      a:not(:hover) {
        text-decoration: underline;
      }
      strong {
        font-size: 16px;
      }
    }
  }
`
